import React from 'react';

import { Wrapper } from './parts';

interface IProps {
  smsTermsContent?: string;
}
const Footer: React.FC<IProps> = ({ smsTermsContent }) => {
  const smsTermsContentHtml = document.createElement('div');
  smsTermsContentHtml.innerHTML = smsTermsContent || '';

  return (
    <Wrapper
      className="Footer"
      dangerouslySetInnerHTML={{
        __html: smsTermsContentHtml.innerText,
      }}
    />
  );
};

export default Footer;
